<ion-content fullscreen="true" class="transparent-modal">
  <swiper-container init="false" #swiperEl>
    <swiper-slide>
      <div class="swiper-zoom-container">
        <img [alt]="'Etiqueta._Foto' | translate" [src]="urlImage()" draggable="false" />
      </div>
    </swiper-slide>
  </swiper-container>
</ion-content>

<ion-footer>
  <ion-row>
    <ion-col size="4" class="ion-text-center">
      <ion-button (click)="zoom(false)" fill="clear" color="tech-blue">
        <mat-icon slot="icon-only" color="deep-black" style="color: var(--ion-color-tech-blue) !important">zoom_out
        </mat-icon>
      </ion-button>
    </ion-col>
    <ion-col size="4" class="ion-text-center">
      <ion-button (click)="close()" fill="clear" color="tech-blue">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-col size="4" class="ion-text-center">
      <ion-button (click)="zoom(true)" fill="clear" color="tech-blue">
        <mat-icon slot="icon-only" color="deep-black" style="color: var(--ion-color-tech-blue) !important">zoom_in
        </mat-icon>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>